import { render } from "./app.vue?vue&type=template&id=3984725d&ts=true"
import script from "./app.component.ts?vue&type=script&lang=ts"
export * from "./app.component.ts?vue&type=script&lang=ts"

import exportComponent from "/Volumes/ExDisk/Cong viec/LuvTransitltms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__